import { z } from 'zod';

/** Человек сам включает или выключает необязательное согласие в профиле. */
export const setConsentSchema = z.object({
  granted: z.boolean(),
});
export type SetConsentInput = z.infer<typeof setConsentSchema>;

/**
 * Удаление своего аккаунта.
 *
 * Пароль — потому что действие необратимо и выполняется сразу: открытая
 * чужим человеком вкладка не должна стирать аккаунт одним щелчком.
 */
export const deleteOwnAccountSchema = z.object({
  password: z.string().min(1, 'Введите пароль'),
});
export type DeleteOwnAccountInput = z.infer<typeof deleteOwnAccountSchema>;

/**
 * Администратор записывает отзыв согласия по обращению человека.
 *
 * Основание обязательно: запись в журнале без причины через год ничего не
 * объяснит. Персональных данных в основании не пишут — достаточно «письмо на
 * support@ от 15.10.2026».
 */
export const adminWithdrawConsentSchema = z.object({
  note: z.string().trim().min(3, 'Укажите основание: например, «письмо на support@ от 15.10»').max(300),
});
export type AdminWithdrawConsentInput = z.infer<typeof adminWithdrawConsentSchema>;

/**
 * Удаление аккаунта администратором по обращению.
 *
 * Почту аккаунта нужно ввести целиком: так случайный щелчок по соседней
 * строке списка не сотрёт не того человека.
 */
export const adminEraseUserSchema = z.object({
  confirmEmail: z.string().trim().min(3).max(254),
});
export type AdminEraseUserInput = z.infer<typeof adminEraseUserSchema>;

/** Отписка по ссылке из письма: токен приходит телом, как и подтверждение почты. */
export const unsubscribeSchema = z.object({
  token: z.string().min(16, 'Ссылка неполная').max(512),
});
export type UnsubscribeInput = z.infer<typeof unsubscribeSchema>;

export const guestSearchSchema = z.object({
  q: z.string().trim().min(2, 'Введите хотя бы две буквы имени').max(80),
});
